export default __webpack_public_path__ + "media/siteware/favicon-150-8fd5f99e13c997463111210c67ec6a5f.png";